import React, {useState, useEffect} from 'react'
import {Link} from 'react-router-dom';
import { useActiveLinks} from '../../hooks/useActiveLinks';
import { useActiveCurrentPath } from '../../hooks/useActiveCurrentPath';
import {useArticles} from '../../hooks/hooks-mongoDB/useArticles';

import AbwinesMm from '../../images//header/mobilemenu/InfoWineMmW265.png';
import ChoosewinesMm from '../../images/header/mobilemenu/ChooseWineMmW265.png';
import TastewinesMm from '../../images/header/mobilemenu/TastingWineMmW265.png';
//import ProvinceMm from '../../images/header/mobilemenu/AbruzzoMnW265.png';
//import TipologiaMm from '../../images/header/mobilemenu/TipologiaMmW265.png';
//import VitignoMm from '../../images/header/mobilemenu/VitigniMmW265.png';

import SagreMm from '../../images/header/mobilemenu/SagreMmW265.png';
import EventwinesMm from '../../images/header/mobilemenu/EventiEnogastroMmW265.png'
//import ShopwinesMm from '../../images/header/mobilemenu/CatalogoMmW265.png'
import QuizMm from '../../images/header/mobilemenu/QuizMmW265.png'
//import ArgumentoMm from '../../images/header/mobilemenu/ArgumentoMmW265.png'

import Icontiktok from '../../images/icons/SocialIconTikTokW96.png';
import IconTwitter from '../../images/icons/SocialIconXW96.png';
import IconInsta from '../../images/icons/SocialIconInstagramW96.png';
import IconFB from '../../images/icons/SocialIconfbW96.png';
//import IconWApp from '../../images/icons/SocialIconWAW96.png';
import IconLinkdin from '../../images/icons/SocialIconLinkdinW96.png';
import IconYT from '../../images/icons/SocialIconYTW96.png';

import normalImage from '../../images/icons/iconHomeNavbar.png';
import hoverImage from '../../images/icons/iconHomeNavbarYellow.png';
import logoSite from '../../images/header/LogoW430.png';
import { ProfileIcon } from '../../svgs/EvironemtIcon';
import './menumobile.scss';

/*
* Function  for the menu in tree generals themes.
* setember 03st, 2025
*/
export function MenuMobile({temi}) {
    const links = useActiveLinks();
    const [argumt, setArgumt] = useState([]);
    const originalData = temi || [];
    const filteredData = originalData.length >= 9 
        ? [
            ...originalData.slice(0, 4),  // Elementi 0-3
            ...originalData.slice(8)      // Elementi 8+
            ]
        : originalData; // Se non ci sono abbastanza elementi, usa tutto

    // Passa filteredData all'hook
    const currentPath = useActiveCurrentPath(filteredData);
    // Usa currentPath nel componente

    useEffect(() => {
        setArgumt(currentPath)
    }, [argumt, currentPath]);  

    return (
        <div className="ctn-menu__mobile">
            {argumt && <div className="menu-mobile__felt">
                {links.linkOne ? (<div className="mobile__s-box">
                    <img src={AbwinesMm} alt="Mondo vini attivo" />
                    <div>
                        <Link to="/ilmondodeiviniabruzzese">
                            <button className="cmd-btn__ms">
                                <span>Ti trovi in</span>
                            </button>
                        </Link>
                    </div>
                </div>)
                :
                (<div className="mobile__box btn__t-color">
                    <img src={AbwinesMm} alt="Mondo vini attivo" />
                    <div>
                        <Link to="/ilmondodeiviniabruzzese">
                            <button className="cmd-btn__ms">
                                <span>Abruzzo </span>
                            </button>
                        </Link>
                    </div>
                </div>)}

                {links.linkTwo ? (<div className="mobile__s-box">
                    <img src={ChoosewinesMm} alt="" />
                    <div>
                        <Link to="/sceglierebeneivini">
                            <button className="cmd-btn__ms">
                                <span>Ti trovi in</span>
                            </button>
                        </Link>
                    </div>
                </div>)
                :
                (<div className="mobile__box btn__t-color">
                    <img src={ChoosewinesMm} alt="" />
                    <div>
                        <Link to="/sceglierebeneivini">
                            <button className="cmd-btn__ms">
                                <span>Scelta </span>
                            </button>
                        </Link>
                    </div>
                </div>)}

                {links.linkThree ? (<div className="mobile__s-box">
                    <img src={TastewinesMm} alt="" />
                    <div>
                        <Link to="/degustazionedeivini">
                            <button className="cmd-btn__ms">
                                <span>Ti trovi in</span>
                            </button>
                        </Link>
                    </div>
                </div>)
                :
                (<div className="mobile__box btn__t-color">
                    <img src={TastewinesMm} alt="" />
                    <div>
                        <Link to="/degustazionedeivini">
                            <button className="cmd-btn__ms">
                                <span>Degustazione </span>
                            </button>
                        </Link>
                    </div>
                </div>)}
            </div>}

            {argumt && <div className="menu-mobile__felt">
                {links.linkSeven ? (<div className="mobile__s-box">
                    <img src={EventwinesMm} alt="" />
                    <div>
                        <Link to="/ilmondodeiviniabruzzese/eventiEnogastronomoci">
                            <button className="cmd-btn__ms" >
                                <span>Ti trovi in</span>
                            </button>
                        </Link>
                    </div>
                </div>)
                :
                (<div className="mobile__box btn__t-color">
                    <img src={EventwinesMm} alt="" />
                    <div>
                        <Link to="/ilmondodeiviniabruzzese/eventiEnogastronomoci">
                            <button className="cmd-btn__ms" >
                                <span>Eventi </span>
                            </button>
                        </Link>
                    </div>
                </div>)}

                {links.linkEight ? (<div className="mobile__s-box">
                    <img src={SagreMm} alt="" />
                    <div>
                        <Link to="/sagredellabruzzo">
                            <button className="cmd-btn__ms" >
                                <span>Ti trovi in</span>
                            </button>
                        </Link>
                    </div>
                </div>)
                :
                (<div className="mobile__box btn__t-color">
                    <img src={SagreMm} alt="" />
                    <div>
                        <Link to="/sagredellabruzzo">
                            <button className="cmd-btn__ms" >
                                <span>Sagre </span>
                            </button>
                        </Link>
                    </div>
                </div>)}

                {links.linkTen ? (<div className="mobile__s-box">
                    <img src={QuizMm} alt="" />
                    <div>
                        <Link to="/enoquizabruzzo">
                            <button className="cmd-btn__ms" >
                                <span>Ti trovi in</span>
                            </button>
                        </Link>
                    </div>
                </div>)
                :
                (<div className="mobile__box btn__t-color">
                    <img src={QuizMm} alt="" />
                    <div>
                        <Link to="/enoquizabruzzo">
                            <button className="cmd-btn__ms" >
                                <span>Quiz </span>
                            </button>
                        </Link>
                    </div>
                </div>)}
            </div>}
        </div>
    )
}

/*
* Function for the menu one in redut screen.
* setember 03st, 2025
*/

export function MenuOneDropDown({ themes, articles, handlerCloseBurger, scrollCurrent, isAuthenticated }) {
    const [isHovered, setIsHovered] = useState(false);
    // Componente 1 - Carica articles di tipologia
    const { articles: articles_One } = useArticles('tipologia');
    const arts_Tipologia = articles_One || [];
    // Componente 2 - Carica articles di vitigno
    const { articles: articles_Two } = useArticles('vitigno');
    const arts_vitigni = articles_Two || [];
    // Safe access with proper checking
    const regione_Theme = themes[3] || {}; // This is likely an object, not array
    const tipo_Theme = themes[8] || {};
    const vitigno_Theme = themes[9] || {};
    const shop_Theme = themes[13] || {};
    // Componente 3 - Carica articles di province
    const aquila_Theme = themes[4]? (themes[4].accordion || []) : []; // Prende direttamente l'elemento all'indice Aquila
    const chieti_Theme = themes[5]? (themes[5].accordion || []) : []; // Prende direttamente l'elemento all'indice chieti
    const pescara_Theme = themes[6]? (themes[6].accordion || []) : []; // Prende direttamente l'elemento all'indice pescara 
    const teramo_Theme = themes[7]? (themes[7].accordion || []) : []; // Prende direttamente l'elemento all'indice teramo

    const abruzzo = [aquila_Theme, chieti_Theme, pescara_Theme, teramo_Theme]
        .filter(accordionArray => Array.isArray(accordionArray) && accordionArray.length > 0)
        .map(accordionArray => accordionArray[0]);  // Prende solo il primo oggetto

     // Array finale con le proprietà richieste:
    const provinceData = abruzzo.map(provincia => ({
        name: provincia?.sotto_titolo || '',
        id_accord: provincia?.id_accord || 0,
        collegamento: "/provincedellabruzzo" + provincia?.name?.toLowerCase() || '#'
    }));

    const tipo_Links = arts_Tipologia.map(article => ({
        id: article._id, 
        titolo: article.articolo_titolo, 
        collegamento: article.collegamento
    }));

    const vitigno_Links = arts_vitigni.map(article => ({
        id: article._id, 
        titolo: article.articolo_titolo, 
        collegamento: article.collegamento
    }));

    return (
        <div className="nav-container">
            <div className="nav-item__home" onClick={handlerCloseBurger}>
                <Link to="/" className="nav-link" onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
                    <img className={`hover-effect ${isHovered ? 'hovered' : ''}`} src={isHovered ? hoverImage : normalImage} alt="icon for home" />  
                </Link>
            </div>
            
            {/* Province Dropdown */}
            {regione_Theme && (
                <div className="nav-item" onClick={handlerCloseBurger}>
                    <Link className="nav-link" to="/provincedellabruzzo" state={{index: 0}}>
                        {regione_Theme?.titolo || 'Province'}<div className="arrow-down"></div>
                    </Link>
                    <div className="dropdown-menu">
                        <div className="dropdown-item">
                            {provinceData.map((elt, index) => (
                                <Link to="/provincedellabruzzo" className="dropdown-link" key={elt.id_accord} state={{index: elt.id_accord}}>
                                    <i>{elt?.name || 'Item'}</i> 
                                </Link>
                            ))}
                        </div>
                    </div>    
                </div>
            )}
            
            {/* Tipologia Dropdown */}
            {tipo_Theme && (
                <div className="nav-item" onClick={handlerCloseBurger}>
                    <Link className="nav-link" to={tipo_Theme?.collegamento || '#'}>
                        {tipo_Theme?.titolo || 'Tipologia'}<div className="arrow-down"></div>
                    </Link>
                    <div className="dropdown-menu">
                        <div className="dropdown-item">
                            {tipo_Links.map((elt, index) => (
                                <Link to={elt.collegamento} className="dropdown-link" key={elt.id || index}>
                                    <i>{elt.titolo}</i> 
                                </Link>
                            ))}
                        </div>
                    </div>
                </div>
            )}
            
            {/* Vitigni Dropdown */}
            {vitigno_Theme && (
                <div className="nav-item" onClick={handlerCloseBurger}>
                    <Link className="nav-link" to={vitigno_Theme?.collegamento || '#'}>
                        {vitigno_Theme?.titolo || 'Vitigni'}<div className="arrow-down"></div>
                    </Link>
                    <div className="dropdown-menu">
                        <div className="dropdown-item">
                            {vitigno_Links.map((elt, index) => (
                                <Link to={elt.collegamento} className="dropdown-link" key={elt.id || index}>
                                    <i>{elt.titolo}</i> 
                                </Link>
                            ))}
                        </div>
                    </div>
                </div>
            )}
            
            {/* Shop Link */}
            {shop_Theme && (
                <div className="nav-item" onClick={handlerCloseBurger}>
                    <Link to={shop_Theme?.collegamento || '#'} className="nav-link nav-title">
                        {shop_Theme?.titolo || 'Shop'}
                    </Link>
                </div>
            )}

            {/* Profile */}
            {isAuthenticated && (
                <div className="nav-item" onClick={handlerCloseBurger}>
                    <Link to="profile" className="nav-link nav-title" title='Mio Profilo'>
                        <ProfileIcon className="profile-icon" width={20} height={20}/>
                    </Link>
                </div>
            )}
        </div>
    );
}

/*
* Function for the menu two in redut screen.
* setember 03st, 2025
*/
export function MenuTwoDropDown({ themes, articles, handlerCloseBurger, scrollCurrent }) {
    // Componente 1 - Carica articles di abruzzowines
    const { articles: articles_One } = useArticles('abruzzowines');
    const arts_abruzzowines = articles_One || [];
    // Componente 2 - Carica articles di choosewines
    const { articles: articles_Two } = useArticles('choosewines');
    const arts_choosewines = articles_Two || [];
    // Componente 3 - Carica articles di tastewines
    const { articles: articles_Tree } = useArticles('tastewines');
    const arts_tastewines = articles_Tree || [];
    // Safe access with proper checking
    const mundoab_Theme = themes[0] || {}; // Prende direttamente il tema all'indice 0 - Mundo vino Abruzzo
    const scelta_Theme = themes[1] || {}; // Prende direttamente il tema all'indice 1 - Scelta dei vini
    const taste_Theme = themes[2] || {}; // Prende direttamente il tema all'indice 2 - Degustazione
    const quiz_Theme = themes[10] || {}; // Prende direttamente il tema all'indice 10 - Quiz Sparetimes
    const sagre_Theme = themes[11] || {}; // Prende direttamente il tema all'indice 11 - Sagre

    const mundoab_Links = arts_abruzzowines.map(article => ({
        id: article._id, 
        titolo: article.articolo_titolo, 
        collegamento: article.collegamento
    }));

    const scelta_Links = arts_choosewines.map(article => ({
        id: article._id, 
        titolo: article.articolo_titolo, 
        collegamento: article.collegamento
    }));

    const taste_Links = arts_tastewines.map(article => ({
        id: article._id, 
        titolo: article.articolo_titolo, 
        collegamento: article.collegamento
    }));

    return (
        <div className="nav-container nbb">
            {/* Mundo Abruzzo Dropdown */}
            {mundoab_Theme && (
                <div className="nav-item" onClick={handlerCloseBurger}>
                    <Link className="nav-link" to={mundoab_Theme?.collegamento || '#'}>
                        {mundoab_Theme?.titolo || 'Abruzzo'}<div className="arrow-down"></div>
                    </Link>
                    <div className="dropdown-menu">
                        <div className="dropdown-item">
                            {mundoab_Links.map((elt, index) => (
                                <Link to={elt.collegamento} className="dropdown-link" key={elt.id || index}>
                                    <i>{elt.titolo}</i> 
                                </Link>
                            ))}
                        </div>
                    </div>    
                </div>
            )}
            
            {/* Scelta Dropdown */}
            {scelta_Theme && (
                <div className="nav-item" onClick={handlerCloseBurger}>
                    <Link className="nav-link" to={scelta_Theme?.collegamento || '#'}>
                        {scelta_Theme?.titolo || 'Scelta'}<div className="arrow-down"></div>
                    </Link>
                    <div className="dropdown-menu">
                        <div className="dropdown-item">
                            {scelta_Links.map((elt, index) => (
                                <Link to={elt.collegamento} className="dropdown-link" key={elt.id || index}>
                                    <i>{elt.titolo}</i> 
                                </Link>
                            ))}
                        </div>
                    </div>
                </div>
            )}
            
            {/* Taste Dropdown */}
            {taste_Theme && (
                <div className="nav-item" onClick={handlerCloseBurger}>
                    <Link className="nav-link" to={taste_Theme?.collegamento || '#'}>
                        {taste_Theme?.titolo || 'Deg.'}<div className="arrow-down"></div>
                    </Link>
                    <div className="dropdown-menu">
                        <div className="dropdown-item">
                            {taste_Links.map((elt, index) => (
                                <Link to={elt.collegamento} className="dropdown-link" key={elt.id || index}>
                                    <i>{elt.titolo}</i> 
                                </Link>
                            ))}
                        </div>
                    </div>
                </div>
            )}
            
            {/* Quiz Link */}
            {quiz_Theme && (
                <div className="nav-item" onClick={handlerCloseBurger}>
                    <Link to={quiz_Theme?.collegamento || '#'} className="nav-link nav-title">
                        {quiz_Theme?.titolo || 'Quiz'} 
                    </Link>
                </div>
            )}
            
            {/* Sagre Link */}
            {sagre_Theme && (
                <div className="nav-item" onClick={handlerCloseBurger}>
                    <Link to={sagre_Theme?.collegamento || '#'} className="nav-link nav-title">
                        {sagre_Theme?.titolo || 'Sagre'} 
                    </Link>
                </div>
            )}
        </div>
    );
}

/*
* Function element for social links navbar.
* May 17st, 2023
*/
export function SocialLinks() {

    return (
        <div className="social__links" >
            <div className="link__ctn">
                <img src={IconInsta} alt="link for infos Wine" title='Instagram'/>
            </div>
            <div className="link__ctn">
                <img src={IconTwitter} alt="link for infos Wine" title='X'/>
            </div>
            <div className="link__ctn">
                <img src={IconFB} alt="link for infos Wine" title=''/>
            </div>
            <div className="link__ctn">
                <img src={Icontiktok} alt="link for infos Wine" title='TikTok'/>
            </div>
            <div className="link__ctn">
                <img src={IconYT} alt="link for infos Wine" title='YouTube'/>
            </div>
            <div className="link__ctn">
                <img src={IconLinkdin} alt="link for infos Wine" title='Linkdin'/>
            </div> 
        </div>
    )
}

/*
* Function element for manifest menu links navbar.
* May 17st, 2023
*/

export function MenuManifesti({ themes, handlerCloseBurger, scrollCurrent}) {
    //const themesData = themes?.data || [];
    const mundoab_Theme = themes[0]; // Prende direttamente il tema all'indice 3 - Mundo vino Abruzzo
    const scelta_Theme = themes[1]; // Prende direttamente il tema all'indice 8 - Scelta dei vini
    const taste_Theme = themes[2]; // Prende direttamente il tema all'indice 9 - Degustazione
    const quiz_Theme = themes[10]; // Prende direttamente il tema all'indice 14 - Quiz Sparetimes
    const sagre_Theme = themes[11]; // Prende direttamente il tema all'indice 14 - Sagre
    const event_Theme = themes[12]; // Prende direttamente il tema all'indice 14 - Sagre
    //const shop_Theme = themes[13]; // Prende direttamente il tema all'indice 14 - catalogo

    const menuOne = [event_Theme, sagre_Theme, quiz_Theme].filter(item => 
        item && typeof item === 'object'
    );
    const menuTwo = [mundoab_Theme, scelta_Theme, taste_Theme].filter(item => 
        item && typeof item === 'object'
    );

    return (
        <div className="content-burger"> 
            <div className="burger-event">
                <div className="burger-mscreen">
                {menuOne.map((item, index) => (
                    <div className='box__ms' key={index}>
                        <img src={require(`../../../components/images/${item.img_Mm}`)} alt={`${item.name} theme`} /> 
                        <div onClick={handlerCloseBurger}>
                            <Link to={item.collegamento}>
                                <button><span>{item.nav_title} </span></button>
                            </Link>
                        </div>    
                    </div>))}
                </div>
            </div>

            <div className="burger-event mb-2">
                <div className="burger-mscreen">
                {menuTwo.map((item, index) => (
                    <div className='box__ms'>
                        <img src={require(`../../../components/images/${item.img_Mm}`)} alt={`${item.name} theme`} />
                        <div onClick={handlerCloseBurger}>
                            <Link to={item.collegamento}>
                                <button><span>{item.nav_title} </span></button>
                            </Link>
                        </div>    
                    </div>))}
                </div>
            </div>
        </div>
    )
};

/*
* Function element for manifest menu links navbar in header.
* May 17st, 2023
*/
export function FirstHeadManifestMenu ({themes, scrollCurrent}) {
    const themesData = themes || [];
    const quiz_Theme = themesData[10]; // Prende direttamente il tema all'indice 14 - Quiz Sparetimes
    const sagre_Theme = themesData[11]; // Prende direttamente il tema all'indice 14 - Sagre
    const event_Theme = themesData[12]; // Prende direttamente il tema all'indice 14 - Sagre
    const shop_Theme = themesData[13]; // Prende direttamente il tema all'indice 14 - catalogo
    const menu = [ event_Theme, sagre_Theme, shop_Theme, quiz_Theme].filter(item => 
        item && typeof item === 'object'
    );

    return (
        <div className="header-content__fs">
            <div className='content-logo'>
                <div className="logo">
                    <img src={logoSite} 
                        className='logo-img' 
                        alt="site's logo"
                    />
                </div>
            </div>
            <div className='full-screen'>
            {menu.map((item, index) => (
                <div className='box__fs' key={index}>
                    <img src={require(`../../../components/images/${item.img_Fmm}`)} alt={`${item.name} theme`} />
                    <div className='cmd-box'>
                        <p className='cmd-commentary'>{item.commentary_Fmm}</p>
                        <Link className="btn__link" state={{scrollCurrent}} to={item.collegamento}>
                            <button className="cmd-btn"><span>{item.nav_title} </span></button>
                        </Link>
                    </div>
                </div>))}
            </div>
        </div>
    )
};

/*
* Function element for second manifest menu links navbar in header.
* May 17st, 2023
*/
export function SecondHeadManifestMenu ({themes, scrollCurrent}) {
    const themesData = themes || [];
    const quiz_Theme = themesData[10]; // Prende direttamente il tema all'indice 14 - Quiz Sparetimes
    const sagre_Theme = themesData[11]; // Prende direttamente il tema all'indice 14 - Sagre
    const event_Theme = themesData[12]; // Prende direttamente il tema all'indice 14 - Sagre
    const shop_Theme = themesData[13]; // Prende direttamente il tema all'indice 14 - catalogo

    const menuOne = [event_Theme, sagre_Theme].filter(item => 
        item && typeof item === 'object'
    );
    const menuTwo = [shop_Theme, quiz_Theme].filter(item => 
        item && typeof item === 'object'
    );

    return (
        <div className="header-content__ms">
            <div className='content-logo'>
                <div className="logo">
                    <img src={logoSite} 
                        className='logo-img' 
                        alt="site's logo"
                    />
                </div>
            </div>
            <div className="medium-screen">
            {menuOne.map((item, index) => (
                <div className='box__ms' key={index}>
                    <img src={require(`../../../components/images/${item.img_Mm}`)} alt={`${item.name} theme`} />
                    <div>
                        <Link state={{scrollCurrent}} to={item.collegamento}>
                            <button className="cmd-btn__ms"><span>{item.nav_title} </span></button>
                        </Link>
                    </div>    
                </div>))}
            </div>
            <div className="medium-screen">
            {menuTwo.map((item, index) => (
                <div className='box__ms' key={index}>
                    <img src={require(`../../../components/images/${item.img_Mm}`)} alt={`${item.name} theme`} />
                    <div>
                        <Link state={{scrollCurrent}} to={item.collegamento}>
                            <button className="cmd-btn__ms"><span>{item.nav_title} </span></button>
                        </Link>
                    </div>    
                </div>))}
            </div>
        </div>     
    )
};
